import { createAction, props } from '@ngrx/store';
import { ILoaderActionPayload } from '../models/loader.model';
import {
  EntityMediaItem,
  EntityMediaResponse,
  ProcedureItem,
  ProcedureItemList,
  ProcedureStatusHistoryItemList,
  ProcedureStatusItemList,
  ProcedureTypeItemList,
} from '../../../api/models';

import {
  EntityMediaControllerDetachAndDelete$Params,
  EntityMediaControllerGetEntityFiles$Params,
  ProcedureControllerCreate$Params,
  ProcedureControllerGetAll$Params,
  ProcedureControllerGetAllStatuses$Params,
  ProcedureControllerGetOne$Params,
  ProcedureControllerUpdateProcedureStatus$Params,
} from '../../../api/functions';

export const proceduresActions = {
  //findAll
  load: createAction('load/procedures', props<ProcedureControllerGetAll$Params>()),
  done: createAction('load/procedures/done', props<{ state: ILoaderActionPayload; data?: ProcedureItemList }>()),
  //findOne
  loadOne: createAction('load/procedures/load-one', props<ProcedureControllerGetOne$Params>()),
  doneOne: createAction('load/procedures/done-one', props<{ state: ILoaderActionPayload; data?: ProcedureItem }>()),

  //create
  createOne: createAction('procedures/create-one', props<ProcedureControllerCreate$Params>()),
  createOneDone: createAction(
    'procedures/create-one/done',
    props<{ state: ILoaderActionPayload; data?: ProcedureItem }>(),
  ),
  createOneSetState: createAction('procadure/create-one/set-state', props<{ state: ILoaderActionPayload }>()),

  //change procedure status
  changeProcedureStatus: createAction(
    'procedures/change-status',
    props<ProcedureControllerUpdateProcedureStatus$Params>(),
  ),
  changeProcedureStatusDone: createAction(
    'procedures/change-status/done',
    props<{ state: ILoaderActionPayload; data?: ProcedureItem }>(),
  ),
  changeProcedureStatusSetState: createAction(
    'procedures/change-status/setState',
    props<{ state: ILoaderActionPayload }>(),
  ),

  procedureStatusesLoad: createAction('procedure/statuses/load'),
  procedureStatusesDone: createAction(
    'procedure/statuses/done',
    props<{ state: ILoaderActionPayload; data?: ProcedureStatusItemList }>(),
  ),

  procedureTypesLoad: createAction('procedure/types/load'),
  procedureTypesDone: createAction(
    'procedure/types/done',
    props<{ state: ILoaderActionPayload; data?: ProcedureTypeItemList }>(),
  ),

  // stati disponibili
  nextStatusesLoad: createAction('procedure/next-statuses/load', props<{ id: number }>()),
  nextStatusesDone: createAction(
    'procedure/next-statuses/done',
    props<{ state: ILoaderActionPayload; data?: ProcedureStatusItemList }>(),
  ),

  //load media
  loadOneMedia: createAction('procedures/load-media', props<EntityMediaControllerGetEntityFiles$Params>()),
  loadOneMediaDone: createAction(
    'procedures/load-media/done',
    props<{
      state: ILoaderActionPayload;
      data?: EntityMediaResponse;
    }>(),
  ),
  loadOneMediaSetState: createAction('procedures/load-media/state', props<{ state: ILoaderActionPayload }>()),

  deleteOneMedia: createAction('procedures/delete-media', props<EntityMediaControllerDetachAndDelete$Params>()),
  deleteOneMediaDone: createAction(
    'procedures/delete-media/done',
    props<{
      state: ILoaderActionPayload;
      data?: EntityMediaItem;
      entity_id: number;
    }>(),
  ),
  deleteOneMediaSetState: createAction('procedures/delete-media/state', props<{ state: ILoaderActionPayload }>()),
};
